import { AbschlussKategorie, Ausbildung, Berufserfahrung, Bild, Ehrenamt, Lehre, Schule, Studium } from '../../models/unterlagen.model';
import { formatDate } from '../../services/date-utils';
import { AusbildungDto, BerufserfahrungDto, BildDto, EhrenamtDto, LehreDto, SchuleDto, StudiumDto } from '../dto/unterlagen.dto';

export function toBerufserfahrungDto(berufserfahrung: Berufserfahrung): BerufserfahrungDto {
  return {
    ...berufserfahrung,
    von: formatDate(berufserfahrung.von, false),
    bis: berufserfahrung.bis !== null ? formatDate(berufserfahrung.bis, false) : null
  };
}

export function toSchuleDto(schule: Schule): SchuleDto {
  return {
    ...schule,
    ende: schule.ende !== null ? formatDate(schule.ende, false) : null
  };
}

export function toStudiumDto(studium: Studium): StudiumDto {
  return {
    ...studium,
    von: formatDate(studium.von, false),
    bis: studium.bis !== null ? formatDate(studium.bis, false) : null
  };
}

export function toLehreDto(lehre: Lehre): LehreDto {
  return {
    ...lehre,
    von: formatDate(lehre.von, false),
    bis: lehre.bis !== null ? formatDate(lehre.bis, false) : null
  };
}

export function toAusbildungDto(ausbildung: Ausbildung): AusbildungDto {
  switch (ausbildung.typ) {
    case AbschlussKategorie.schule:
      return toSchuleDto(ausbildung);
    case AbschlussKategorie.lehre:
      return toLehreDto(ausbildung);
    case AbschlussKategorie.studium:
      return toStudiumDto(ausbildung);
    default: {
      throw new Error('Unexpected Ausbildung type in toAusbildungDto');
    }
  }
}

export function toEhrenamtDto(ehrenamt: Ehrenamt): EhrenamtDto {
  return {
    ...ehrenamt,
    von: formatDate(ehrenamt.von, false),
    bis: ehrenamt.bis !== null ? formatDate(ehrenamt.bis, false) : null
  };
}

export function toBildDto(bild: Bild): BildDto {
  return {
    src: bild.src,
    grayscale: bild.grayscale
  };
}
